import Main from "./Components/Main";
import "./App.css";
import "animate.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { BrowserRouter } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import { Provider } from "react-redux";
import store from "./Redux/store";
import { QueryClient, QueryCache, QueryClientProvider } from "react-query";
import { TOKEN_KEY } from "./Shared/Tokens";
import { Suspense } from "react";
import Loader from "./Components/Common/Loader/Loader";
import TawkMessenger from "tawkmessenger";
declare module "react-query/types/react/QueryClientProvider" {
  interface QueryClientProviderProps {
    children?: any;
  }
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: async (error: any, query) => {
      if (error.request.status === 401) {
        localStorage.removeItem(TOKEN_KEY);
        window.location.reload();
      }
    },
  }),
});

function App() {
  return (
    // <PDFViewer>
    <Suspense fallback={<Loader opened />}>
      {/* <PDFViewer> */}

      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <TawkMessenger
              // get propertyId from .env
              propertyId={process.env.REACT_APP_TAWK_TO_PROPERTY_ID}
              widgetId={process.env.REACT_APP_TAWK_TO_WIDGET_ID}
            />
            <Main />
            <NotificationContainer />
          </BrowserRouter>
        </QueryClientProvider>
      </Provider>
      {/* </PDFViewer> */}
    </Suspense>
    // </PDFViewer>
  );
}

export default App;
